module.exports = __webpack_public_path__ + "fonts/font.7e95fee2.woff";